import EmptyView from '@/views/empty-view.vue';

export default {
  name: 'tradelink',
  path: '/tradelink',
  meta: { authenticated: true, activeUser: true, title: 'TradeLink' },
  component: EmptyView,
  beforeEnter(to, from, next) {
    console.log('do tradelink things...');

    return next({ name: 'root' });
  },
};
